module.exports = __webpack_public_path__ + "img/ai-control.940d3b25.png";